import { FunctionComponent, useState } from 'react';
import { Button, IconButton } from '../../tailwindcomponents';
import { Close } from '../../components/icons';
import { Typography, Input, Dialog } from './../../tailwindcomponents';
import { CertificateData } from './../../types/certificates'
import IcelandairLogo from '../../assets/icelandairLogo.svg';
import { EmployeeSearch } from '../../components'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import { Chat, Edit, CheckCircle, RemoveCircle, Info } from '../../components/icons';
import authApi from '../../api/auth';
import MessageBox from '../../components/Messages/MessageBox';
import { DateTime } from 'luxon';

type CertificateInfoProps = {
    selectedCertificate: CertificateData,
    closeCertificate: Function,
    infoType: 'top' | 'bottom'
    viewType: 'view' | 'edit' | 'approval' | 'history',
    shouldBeAbleToClose?: boolean,
}

const CertificateTopInfo: FunctionComponent<CertificateInfoProps> = ({ selectedCertificate, closeCertificate, infoType, viewType, shouldBeAbleToClose }) => {
    const timeStamp = new Date();
    const timeStampFormatted = DateTime.fromJSDate(timeStamp).toFormat('dd.LL.yyyy, HH:mm:ss');
    const store = useSelector((state: RootState) => state);
    const allUsers = store.employees.all_employees;
    const [employeeName, setEmployeeName] = useState(selectedCertificate.mechanic_full_name);
    const [employeeSSN, setEmployeeSSN] = useState(selectedCertificate.mechanic_social_security_number);
    const [employeeNumber, setEmployeeNumber] = useState(selectedCertificate.mechanic_employee_number);
    const [employeeNumberDialog, setEmployeeNumberDialog] = useState(false);
    const [messageDialogOpen, setMessageDialogOpen] = useState(false);

    const onSelectedEmployeeRow = (employeeId: number) => {
        if (!employeeId) return;
        const selectedEmployee = allUsers.find(s => s.user_id === employeeId);
        if (!selectedEmployee) return;
        setEmployeeName(selectedEmployee.name);
        setEmployeeSSN(selectedEmployee.ssn);
        selectedCertificate.mechanic_employee_id = selectedEmployee.Id;
        selectedCertificate.mechanic_full_name = selectedEmployee.name;
        selectedCertificate.mechanic_social_security_number = selectedEmployee.ssn;
    }

        const confirmEmployeeNumber = () => {
        if (employeeNumber !== undefined && selectedCertificate.mechanic_employee_id !== undefined) {
            authApi.UpdateHREmployeeNumber(employeeNumber, selectedCertificate.mechanic_employee_id).then(res => {
                selectedCertificate.mechanic_employee_number = employeeNumber;
                setEmployeeNumberDialog(false);
            })
        }
    }

    const hasShopRight = selectedCertificate.certificate_rights?.some((r) => r.rating_name?.includes('CS Shop')) ?? false;

    return (
        <div>
            {infoType === 'top' ?
                <div>
                    <div className="w-full flex flex-wrap">
                        <div className="w-3/4">
                            <Typography color='primary' variant='h1' text={"Icelandair - Authorization Certificate"} align='left' />
                        </div>
                        <div className="w-1/6">
                            <img src={IcelandairLogo} className="h-[50px] bottom-[5px] relative" alt="Logo" />
                        </div>
                        {shouldBeAbleToClose !== false &&
                            <div className="w-1/12">
                                <IconButton onClick={() => closeCertificate()} color="default" >
                                    <Close />
                                </IconButton>
                            </div>
                        }
                    </div>
                    <hr />
                    {selectedCertificate.certificate_id === undefined &&
                        <div className="mt-[1%] w-full flex flex-wrap">
                            <div className="w-full">
                                <Typography variant='h2' text={"Select Employee"} align='left' />
                            </div>
                            <div className="w-1/3 mb-[2%]"> <EmployeeSearch place_holder={"Write employees name"} onSelectedEmployee={(employeeId: number) => onSelectedEmployeeRow(employeeId)} /> </div>
                        </div>
                    }
                    <div className="w-full flex flex-wrap mt-[1%]" >
                        <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} fontWeight='bold' text='Certificate displayed at:' /></div>
                        <div className="lg:w-5/6 w-1/2">{timeStampFormatted}</div>
                        <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} margin={[0, 0, 0, 0]} fontWeight='bold' text='Employee number:' /></div>
                        <div className="lg:w-5/6 w-1/2 flex flex-wrap">
                            <Typography paragraph={true} margin={[0, 0, 0, 0]} text={selectedCertificate.mechanic_employee_number !== undefined ? selectedCertificate.mechanic_employee_number : ''} />
                            {viewType === "edit" &&
                                <div className="h-[18px]">
                                    <IconButton className="h-6" onClick={() => setEmployeeNumberDialog(true)}><Edit color='primary' /></IconButton>
                                </div>
                            }
                        </div>
                        <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} fontWeight='bold' text='Employee name:' /></div>
                        <div className="lg:w-5/6 w-1/2">{employeeName}</div>
                        <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} fontWeight='bold' text='Social Security Number:' /></div>
                        <div className="lg:w-5/6 w-1/2">{employeeSSN}</div>
                        {((viewType === "approval" || viewType === "edit") || viewType === "view") &&
                            <div className="flex flex-wrap">
                                <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} fontWeight='bold' text='Jira Link :' /></div>
                                <div onClick={() => window.open(selectedCertificate.jira_link, '_blank')} className="lg:w-5/6 w-1/2"><Typography textColor='blue' text={selectedCertificate.jira_link === undefined ? "" : selectedCertificate.jira_link} cursor='pointer' /></div>
                            </div>
                        }
                    </div>
                    {hasShopRight && (
                        <div className="flex flex-wrap" >
                            <div className="lg:w-[51.667%] w-1/2 bg-[#ffff00]" >
                                <Typography paragraph fontWeight="bold" text="All component authorizations are restricted to the limitations specified in the ICE Capability List" />
                            </div>
                        </div>
                    )}
                </div>
                :
                infoType === 'bottom' &&
                <div>
                    <div className="w-full flex flex-wrap items-center mt-[1%]" >
                        <div className="w-1/6"><Typography paragraph={true} fontWeight='bold' text='AUTHORIZATION EXPIRY DATE:' /></div>
                        <div className="w-5/6 flex items-center gap-2">
                            <span>{selectedCertificate.certificate_expired_date_text ?? ''}</span>
                            {selectedCertificate.expired_date_status === 'Valid' ? <CheckCircle className="text-green-600" />
                                :
                                selectedCertificate.expired_date_status === 'Expiring' ? <Info color="secondary" />
                                    : (selectedCertificate.certificate_expired_date_text ?? '') !== '' ?
                                    <RemoveCircle color="error" /> : ''
                            }
                        </div>
                    </div>
                    <div className="w-full flex flex-wrap mt-[1%]" >
                        <div className="w-1/6"><Typography paragraph={true} fontWeight='bold' text='Approval sent by:' /></div>
                        <div className="w-5/6">{selectedCertificate.approval_sent_by_full_name}</div>
                        <div className="w-1/6"><Typography paragraph={true} fontWeight='bold' text='Approved by:' /></div>
                        <div className="w-1/3">{selectedCertificate.approved_by_full_name}</div>
                        <div className="w-1/6"><Typography paragraph={true} fontWeight='bold' text='Issue date:' /></div>
                        <div className="w-1/3">{selectedCertificate.quality_assurance_accepted_date_text ?? ''}</div>
                    </div>
                    <div className="w-full flex flex-wrap mt-[1%]" >
                        <div className="w-full"><Typography paragraph={true} fontWeight='bold' text="Authorization shall remain valid provided training, experience and qualifications are maintained. Failure to remain validity will result in suspension of privileges until corrected or longer." /></div>
                    </div>
                    <div className="w-full flex flex-wrap mt-[1%]" >
                        <div className="w-full"><Typography paragraph={true} fontWeight='bold' text="Authorization is limited to Icelandair IS.145.002 approval." /></div>
                    </div>
                    <div className="w-full flex flex-wrap mt-[1%]" >
                        <div className="w-full"><Typography paragraph={true} fontWeight='bold' text="MR005 er 20.07.2022" /></div>
                    </div>
                    <br />
                    <div className="flex flex-wrap">
                        {((viewType === "approval" || viewType === "edit") && selectedCertificate.mechanic_employee_id !== null) &&
                            <div className="flex flex-wrap">
                                <div>
                                    <Typography textDecoration fontWeight='bold' text={"Admin notes"} margin={[0.5, 0, 0, 0]} />
                                </div>
                                <IconButton onClick={() => setMessageDialogOpen(true)}>
                                    <Chat color='primary' />
                                </IconButton>
                            </div>
                        }
                        <Dialog
                            visible={messageDialogOpen}
                            max_width={"md"} title={selectedCertificate.mechanic_full_name!}
                            context={
                                <div>
                                    {selectedCertificate.mechanic_employee_id !== undefined && (
                                        <MessageBox id={selectedCertificate.mechanic_employee_id} editMode={true} type="Certificate" />
                                    )}
                                </div>
                            }
                            onClose={(status: any) => { setMessageDialogOpen(false); }}
                            strict={false}
                            show_options={false}
                        />
                    </div>
                </div>
            }
            <Dialog
                visible={employeeNumberDialog}
                max_width={"md"} title={"Edit Employee Number for " + selectedCertificate.mechanic_full_name}
                context={
                    <div>
                        <div className="flex flex-wrap justify-center">
                            <Input width={60} multiline={false} help_text={""} label_text={"Please enter new employee number"} value={employeeNumber !== undefined ? employeeNumber : ""} onTextChange={(text: string) => setEmployeeNumber(text)} type="text" />
                        </div>
                        <div className="flex justify-center m-2 p-2">
                            <div className="p-2">
                                <Button variant="contained" color="primary" onClick={() => confirmEmployeeNumber()}>Save changes</Button>
                            </div>
                        </div>
                    </div>
                }
                onClose={(status: any) => setEmployeeNumberDialog(false)}
                strict={false}
                show_options={false}
            />
        </div>
    );
};
export default CertificateTopInfo;
